<app-card-container class="u-flex-row u-flex-justify-content-center">
    <div class="u-container">
        <app-loading-container [loading]="uiSandbox.moveLoading$ | async">
            <app-card class="u-flex-column u-flex-align-items-start">
                <h3>{{ 'REAL_ESTATE_AGENT.EOTS.OTHER_SERVICES.SUBTITLE' | translate }}</h3>
                <p class="u-color-muted u-margin-bottom-triple">{{
                        'STEP_INDICATION' | translate : {
                            start: 4,
                            end: 4
                        }
                    }}</p>

                <div class="__container u-w100p">
                    <form
                        [formGroup]="form"
                        class="__form u-flex-column u-flex-align-items-start u-w100p u-margin-bottom-double-up-to-and-including-tablet-portrait"
                        (ngSubmit)="onSubmit($event)"
                    >
                        <label
                            [innerHTML]="'REAL_ESTATE_AGENT.EOTS.OTHER_SERVICES.OPTIMALISATION.LABEL' | translate"></label>
                        <div class="u-flex-responsive u-flex-align-items-center u-w100p u-margin-bottom">
                            <app-check-input
                                [formControlName]="otherServicesForm.OtherServicesTelecom"
                                [ignoreMinWidth]="true"
                                class="u-flex-1-1-0"
                                [hasMargin]="false"
                                [hasMarginDouble]="false"
                                [option]="serviceTelecom"
                            ></app-check-input>
                        </div>

                        <app-select-input
                            [options]="requestWithoutMoverOptions"
                            [label]="'REAL_ESTATE_AGENT.EOTS.OTHER_SERVICES.SIMULATION_TYPE.LABEL' | translate"
                            [hasMargin]="false"
                            [hasMarginDouble]="true"
                            [formControlName]="otherServicesForm.RequestWithoutMover"
                            [attr.data-testid]="'request-without-mover-input'"
                        >
                        </app-select-input>

                        <app-textarea-input
                            [hasMarginDouble]="true"
                            [hasMargin]="false"
                            class="u-w100p"
                            [label]="'ADDITIONAL_NOTES.LABEL' | translate"
                            [placeholder]="'ADDITIONAL_NOTES.PLACEHOLDER' | translate"
                            [formControlName]="otherServicesForm.AdditionalNotes"
                        ></app-textarea-input>

                        <app-check-input
                            [custom]="false"
                            [option]="realEstateAgentConsentOption"
                            [hasMargin]="false"
                            [hasMarginDouble]="true"
                            [formControlName]="otherServicesForm.RealEstateAgentConsent"
                            [attr.data-testid]="'real-estate-agent-consent-input'"
                        ></app-check-input>

                        <app-previous-submit
                            (previous)="goToPrevious()"
                            [submitDisabled]="uiSandbox.moveLoading$ | async"
                        ></app-previous-submit>
                    </form>

                    <aside
                        class="u-padding-left-double-tablet-landscape-up u-w100p-up-to-and-including-phone-landscape">
                        <app-powered-by-smooved
                            class="u-display-inline-block u-w100p-up-to-and-including-phone-landscape"
                        ></app-powered-by-smooved>
                    </aside>
                </div>
            </app-card>
        </app-loading-container>
    </div>
</app-card-container>
